













import { defineComponent } from '@vue/composition-api';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'ProductHighlights',
  props: {
    value: {
      type: Array as PropType<Array<String>>,
      required: true,
      validator: (value: string[]) => {
        // check if array has only one level
        return !!value.find(v => typeof v === 'string');
      },
    },
  },
});
